import { useTranslation } from '@msdk/common'
import { FieldDefinition, FormFieldDefinition, FormNode } from '@msdk/definitions'
import { Typography } from '@msdk/ui'
import React from 'react'

interface Props {
  node: FormNode
}

export function StringReadonlyRenderer(props: Props) {
  const fd = props.node.value.fieldDefinition as FieldDefinition
  const formD = props.node.value.formDefinition as FormFieldDefinition

  const desc = formD?.overrideDescription ?? fd.description
  const idml = formD?.overrideIDML ?? fd.idml

  const t = useTranslation()

  return (
    <div>
      <Typography variant="body2">{t(idml, desc)}</Typography>
      <Typography variant="body1">{props.node.value.data?.toStringForView() ?? ''}</Typography>
    </div>
  )
}
